import type { InboxNotificationPayload } from '@aline/common';
import { getDocumentRoute } from '@aline/common';
import { getRepositoryRoute } from '@aline/routes';
import type { Apollo } from 'src/gql/generated';

type SignatureDetectedPayload =
  InboxNotificationPayload<Apollo.InboxNotificationKind.SignatureDetected>;

/**
 * One document opens it; several open the Documents page filtered to "Signature detected", since
 * a window counts documents without listing them.
 */
export function getSignatureDetectedInboxView(payload: SignatureDetectedPayload): {
  route: string;
  subtitle: string;
  title: string;
} {
  const { documentCount, latestDocumentId, latestDocumentName, statusAppliedCount } = payload;
  if (documentCount === 1)
    return {
      route: getDocumentRoute(latestDocumentId),
      subtitle:
        statusAppliedCount > 0
          ? 'Status set to Signed. Open it to review the signatures, or change the status back.'
          : 'Open it to review the signatures.',
      title: `Aline AI detected a signature in ${latestDocumentName}`,
    };

  return {
    route: getRepositoryRoute({ filter: 'signatureDetected' }),
    subtitle:
      statusAppliedCount > 0
        ? `${statusAppliedCount} set to Signed. Review them in Documents, or change a status back.`
        : 'Review them in Documents.',
    title: `Aline AI detected signatures in ${documentCount} documents`,
  };
}
